<template>
  <transition name="modal-fade">
    <div
      class="modal-backdrop"
      @click="close('backdrop')"
    >
      <div
        class="modal"
        @click.stop
        role="dialog"
      >
        <div class="modal-header">
          <slot name="header"> </slot>
          <button
            type="button"
            class="btn-close"
            @click="close"
          >
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["backdrop"],
  methods: {
    close(type) {
      if(type == "backdrop" && !this.backdrop) return;
      this.$emit("close");
    }
  }
};
</script>

<style lang="less">
@import "./../assets/style/config.less";
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  min-width: 20rem;
  max-width: 60rem;
  background-color: @white;
  box-shadow: 0.125rem 0.125rem 1rem 0.0625rem rgba(0, 0, 0, 0.6);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}
.modal-header,
.modal-footer {
  padding: 1rem 2rem;
  display: flex;
}
.modal-header {
  border-bottom: 1px solid @b-c-gray;
  color: @gray;
  justify-content: space-between;
  align-items: center;
}
.modal-header h2 {
  margin: 0;
  color: @gray;
  font-size: 0.875rem;
}
.modal-footer {
  border-top: 1px solid @b-c-gray;
  justify-content: flex-end;
  position: relative;
}
.modal-footer button {
  font-size: 0.875rem;
  padding: 0.25rem 0.75rem;
  cursor: pointer;
}
.modal-body {
  position: relative;
  padding: 1.25rem 2rem;
  max-height: 30rem;
  overflow-y: auto;
}
.modal .btn-close {
  border: none 0;
  font-size: 1.25rem;
  padding: 0.5rem;
  cursor: pointer;
  font-weight: bold;
  color: #000;
  opacity: 0.5;
  background-color: transparent;
}
</style>

